import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import {
    Layout, Menu, Breadcrumb, Icon,Card,
  } from 'antd';
import '../../assets/css/App.css';
import routes from '../../model/router';
import Header1 from '../public';
import BicombImg from "../../assets/images/bicomb.jpg";

const {
    Header, Content, Footer, Sider,
  } = Layout;
const SubMenu = Menu.SubMenu;
const { Meta } = Card;

const Ajax = require('axios');


class Bicomb extends React.Component{

    constructor(props){
        super(props);
        this.state={

        }
    }

    render(){
        return(
            <div>
              <Header1></Header1>
            <Content style={{ padding: '0 50px' }}>

              <Layout style={{background: '#fff' }}>
                <Sider width={200} style={{ background: '#fff' }}>
                  <Menu
                    mode="inline"
                    defaultSelectedKeys={['1']}
                    defaultOpenKeys={['sub1']}
                    style={{ height: '100%' }}
                  >
                   <SubMenu key="sub1" title={<span><Icon type="user" />Bicomb</span>}>
                     <Menu.Item key="1"><Link to="/bicomb">Introduction</Link></Menu.Item>
                    
                    </SubMenu>

                  </Menu>
                </Sider>
                <Content style={{ padding: '0 50px' }}>

                    <div style={{background: `url(${BicombImg}) no-repeat center center`,height:300, width: "100%",backgroundSize: "cover",}}>
                    <div style={{textAlign:"center",color:"#fff"}}>
                    <br></br><br></br><br></br>

                    <txt style={{fontSize:45,fontWeight:'bold',}}>Bibliographic Items Co-occurrence Matrix Builder</txt><br></br>
                    <txt style={{fontSize:38,fontWeight:'bold',}}>Medical informatics assisted analysis of human diseases</txt>
                    </div>
                    </div>

                    
                    <div>
                    <br></br>
                    <br></br>
                    <txt style={{fontSize:23,fontWeight:'bold',paddingLeft:150,paddingRight:100}}>Introduction of Bibliographic Items Co-occurrence Matrix Builder (Bicomb)</txt>
                    <br></br>
                    <div style={{fontSize:20,paddingLeft:150,paddingRight:200}}>
                    <txt >
                    <br></br>
                    A system named Bibliographic Items Co-occurrence Matrix Builder (Bicomb), is developed to process the literatures or records downloaded from bibliographic databases (such as PubMed, SCI, and CNKI). The feature of Bicomb is as following.
                    <br></br><br></br>1. Extract specific fields in the literature, such as author, journal name, title, publication year, citation, etc.
                    <br></br><br></br>2. Statistics of the frequency of corresponding fields.
                    
                    <br></br><br></br>3. High frequency entries based on threshold are intercepted to form co-occurrence matrix and matrix composed of entries-source literature (such as the matrix composed of the pairs of high frequency words and source literatures).
                    <br></br><br></br>4. Output the high-frequency entries and matrix (TXT formate), and the matrix can be used for further clustering analysis and network analysis of the literatures.
                    
                    <br></br><br></br>Please cite the following study if use the information in this website:
                    <br></br><br></br><txt style={{fontStyle:'italic'}}>J Song, Yin Y , Wang H , et al. A review of original articles published in the emerging field of radiomics. European Journal of Radiology, 2020, 127:108991.</txt><br></br>
                 

                    <br></br><txt style={{fontWeight:'bold'}}>Download:</txt><br></br>
                    Click the <span  style={{fontWeight:'bold'}}><a href='http://www.ciitool.com/dic/Installation_Instruction.zip' target="_blank" rel="noopener noreferrer">Download </a></span> button to get the installation package. <br></br>
                    The current installation package is only available in Chinese.
                    <div>
                    </div>
                    </txt>
                    </div>
                    </div>



                </Content>
                    </Layout>
            </Content>
            </div>
        )
    }
}
export default Bicomb;